import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.account.user.stateData.update;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'ACCOUNT_USER_STATEDATA_UPDATE',
	url: '/account/user/statedata/update.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
